import React, { useState } from 'react';
import Link from 'ati-ui-react/components/Link';
import ComplaintPopup from 'generic/ComplaintPopup';
import { ComplaintButtonStyles } from './ComplaintButtonStyles';

const ComplaintButton = ({ transportUrl, gray = false, children }) => {
  const [isOpenedPopup, setOpenedPopup] = useState(false);

  const openPopup = () => setOpenedPopup(true);
  const closePopup = () => setOpenedPopup(false);

  return (
    <ComplaintButtonStyles>
      <Link type="pseudo" gray={gray} small onClick={openPopup}>
        {children}
      </Link>
      {isOpenedPopup && <ComplaintPopup transportUrl={transportUrl} onClose={closePopup} />}
    </ComplaintButtonStyles>
  );
};

export default ComplaintButton;
